@if (isNotAvailable) {
  <app-not-applicable-label [tooltipDynamicText]="toolTip"></app-not-applicable-label>
} @else {
  <app-status-label [statusLabel]="statusLabel"></app-status-label>
}
